import { AxiosPromise, AxiosRequestConfig } from 'axios';
import Resource from './base/Resource';
import Payment from 'src/entities/Payment';
import { Data, Params } from 'src/services/api-client/resource/base/Resource';
import { logout } from 'src/actions/authentication/login/Login.actions';
import { store } from 'src/store';

export default class PaymentResource extends Resource {
  constructor() {
    super('/payments/:investmentId/');
  }

  public update(id: number, data: Data, params?: Params): AxiosPromise<Payment> {
    this.getHeaders();

    let url: string;
    url = this.route.replace('/:investmentId/', '/' + id);

    let queryParams = {};

    if (params) {
      Object.keys(params).forEach(key => {
        if (this.route.indexOf('/:' + key + '/') !== -1) {
          url = url.replace('/:' + key + '/', '/' + params[key] + '/');
        } else {
          queryParams[key] = params[key];
        }
      });
    }

    const requestConfig: AxiosRequestConfig = {
      params: queryParams,
    };

    return this.httpClient
      .put(url, data, requestConfig)
      .catch((errorResponse) => {
        if (errorResponse.response.data.message.includes('Unauthenticated')) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/api-client/resource/PaymentResource.ts